module.exports = __webpack_public_path__ + "static/media/so_cal_edison.a965bd3b.png";